/**
 * Route for `saved-views-shareable-urls`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { SavedViewsShareableUrlsPage } from "../features/saved-views-shareable-urls/SavedViewsShareableUrlsPage";

export const savedViewsShareableUrlsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/saved-views-shareable-urls",
	component: SavedViewsShareableUrlsPage,
});

export default savedViewsShareableUrlsRoute;
